import axios from "axios";
const baseURL = `${process.env.REACT_APP_SWESUM_BASEURL}`;

const SwesumClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization:
      window.localStorage.getItem("authData") != "undefined" &&
      window.localStorage.getItem("authData") !== null
        ? JSON.parse(window.localStorage.getItem("authData")).accessToken
        : "",
  },
});

SwesumClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      window.localStorage.removeItem("authData");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

SwesumClient.interceptors.request.use((config) => {
  config.headers["Authorization"] =
    window.localStorage.getItem("authData") != "undefined" &&
    window.localStorage.getItem("authData") !== null
      ? JSON.parse(window.localStorage.getItem("authData")).accessToken
      : "";
  return config;
});

export async function getMyProfile() {
  const res = await SwesumClient.get(`/client/mysite`);
  return res.data;
}

export async function getMyEndcustomers() {
  const res = await SwesumClient.get(`/client/mysite/endcustomers`);
  return res.data;
}

export async function getEndCustomer(id) {
  const res = await SwesumClient.get(`/client/mysite/endcustomers/${id}`);
  return res.data;
}

export async function updateClientMySite(clientID, body) {
  const res = await SwesumClient.post(`/client/mysite/updateclient/${clientID}`, body);
  return res;
}

export async function getBalancesMySite(clientId, body) {
  const res = await SwesumClient.post(`/client/mysite/balance/${clientId}`, body);
  return res.data;
}

export async function getReskontraMySite(clientId, date) {
  return await SwesumClient.post(
    `/client/mysite/reskontra/${clientId}?date=${date}`
  );
}



export async function createEndCustomer(body) {
  const res = await SwesumClient.post(
    `client/mysite/endcustomers/create`,
    body
  );
  return res;
}

export async function updateEndCustomer(id, body) {
  const res = await SwesumClient.post(
    `client/mysite/endcustomers/${id}/update`,
    body
  );
  return res;
}

export async function getMyInvoices(options) {
  if (!options) {
    options = {};
  }
  const res = await SwesumClient.post(`/client/mysite/invoices`, options);
  return res.data;
}

export async function getMyInvoiceById(id) {
  const res = await SwesumClient.get(`/client/mysite/invoices/${id}`);
  return res.data;
}

export async function getMyEndcustomerInvoices(id, body) {
  const res = await SwesumClient.post(
    `/client/mysite/invoices/endcustomer/${id}`,
    body
  );
  return res.data;
}

export async function getEndCustomerArticles() {
  const res = await SwesumClient.get(`client/mysite/endcustomerarticles`);
  return res.data;
}

export async function createMyInvoice(body) {
  const res = await SwesumClient.post(`/client/mysite/invoices/create`, body);
  return res.data;
}

export async function getMyReports() {
  try {
    const res = await SwesumClient.get(`/client/mysite/reports`);
    return res.data;
  } catch (e) {
    return e.response;
  }
}

export async function downloadMyReport(reportId) {
  try {
    const res = await SwesumClient.get(
      `/client/mysite/reports/${reportId}/download`,
      {
        responseType: "blob",
      }
    );
    return res;
  } catch (e) {
    return e.response;
  }
}

export async function changePassword(body) {
  try {
    const res = await SwesumClient.post(`/client/mysite/change-password`, body);
    return res;
  } catch (e) {
    return e.response;
  }
}

export async function getMyInfo() {
  const res = await SwesumClient.post(`/client/mysite/info`);
  return res.data;
}

export async function stopActiveInvoice(body) {
  const res = await SwesumClient.post(
    `client/mysite/invoices/action/stop`,
    body
  );
  return res;
}

// <===============  FORTNOX   =============>

export async function myPagesFortnoxSendToClient() {
  const res = await SwesumClient.get(`/client/mysite/fortnox`);
  return res;
}

export async function myPagesFortnoxVerifyGUID(guid) {
  try {
    const res = await SwesumClient.get(`/client/mysite/fortnox/verify/${guid}`);
    return res;
  } catch (e) {
    return e.response;
  }
}

export async function myPagesFortnoxPostAuthVerify(guid, body) {
  const res = await SwesumClient.post(
    `/client/mysite/fortnox/verify/${guid}`,
    body
  );
  return res;
}

export async function myPagesFortnoxGetStatus() {
  return await SwesumClient.get(`/client/mysite/fortnox/status`);
}

export async function myPagesFortnoxGetLabels() {
  return await SwesumClient.get(`/client/mysite/fortnox/labels`);
}
